import React from 'react';

export default function SportIcon({ type = 'Autre', className = '' }) {
  const common = { className };
  switch (type) {
    case 'Football':
      return (
        <svg {...common} viewBox="0 0 64 64" width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="2" fill="none" />
          <g stroke="currentColor" strokeWidth="1.4" fill="none">
            <path d="M32 6 L40 18 L54 22 L45 34 L48 48 L32 42 L16 48 L19 34 L10 22 L24 18 Z" />
          </g>
        </svg>
      );

    case 'Running':
      return (
        <svg {...common} viewBox="0 0 64 64" width="64" height="64" xmlns="http://www.w3.org/2000/svg" fill="none">
          <path d="M20 44c6-2 10-8 18-10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="44" cy="16" r="6" stroke="currentColor" strokeWidth="2" />
          <path d="M34 34c3-2 6-1 8 2l6 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );

    case 'Natation':
    case 'Swimming':
      return (
        <svg {...common} viewBox="0 0 64 64" width="64" height="64" xmlns="http://www.w3.org/2000/svg" fill="none">
          <path d="M8 38c8-6 14-6 22-2 8 4 16 4 26-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M18 44c6-2 10-6 18-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <circle cx="24" cy="18" r="5" stroke="currentColor" strokeWidth="2" />
        </svg>
      );

    case 'Basketball':
      return (
        <svg {...common} viewBox="0 0 64 64" width="64" height="64" xmlns="http://www.w3.org/2000/svg" fill="none">
          <circle cx="32" cy="32" r="22" stroke="currentColor" strokeWidth="2" />
          <path d="M14 32h36" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          <path d="M20 18c6 6 12 12 24 12" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M20 46c6-6 12-12 24-12" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
      );

    case 'Cyclisme':
    case 'Cycling':
      return (
        <svg {...common} viewBox="0 0 64 64" width="64" height="64" xmlns="http://www.w3.org/2000/svg" fill="none">
          <circle cx="18" cy="44" r="8" stroke="currentColor" strokeWidth="2" />
          <circle cx="46" cy="44" r="8" stroke="currentColor" strokeWidth="2" />
          <path d="M18 44l10-16h10l6 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M30 30l6-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );

    case 'Tennis':
      return (
        <svg {...common} viewBox="0 0 64 64" width="64" height="64" xmlns="http://www.w3.org/2000/svg" fill="none">
          <circle cx="28" cy="22" r="8" stroke="currentColor" strokeWidth="2" />
          <path d="M34 28l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M46 40l-6 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );

    default:
      return (
        <svg {...common} viewBox="0 0 64 64" width="64" height="64" xmlns="http://www.w3.org/2000/svg" fill="none">
          <path d="M32 6L44 18L44 46L32 58L20 46L20 18Z" stroke="currentColor" strokeWidth="2" fill="none" />
        </svg>
      );
  }
}
